module.exports = __webpack_public_path__ + "img/news1.55e37506.png";